module.exports = __webpack_public_path__ + "static/media/mace.c305095d.svg";